import * as cn from "classnames";
import { FieldInfo } from "rd-redux-forms";
import * as React from "react";

export interface ErrorMessageProps {
    children: React.ReactChild;
    className?: string;
}

export function ErrorMessage(props: ErrorMessageProps) {
    return <span className={cn("common-error-message", props.className)}>{props.children}</span>;
}

export interface FieldErrorProps {
    field: FieldInfo;
    showLastError?: boolean;
    className?: string;
}

export function FieldError(props: FieldErrorProps) {
    return (
        props.field.visualState === "invalid" && (
            <ErrorMessage className={props.className}>
                {props.field.hasCustomErrors || props.field.isParsed === false
                    ? props.showLastError
                        ? capitalizeError(props.field.errors[props.field.errors.length - 1])
                        : capitalizeError(props.field.errors[0])
                    : "Please fill this field."}
            </ErrorMessage>
        )
    );
}

function capitalizeError(text: string) {
    return text[0].toUpperCase() + text.slice(1);
}
